<template>
    <v-content>
      <v-container fluid>
        <h1 class="py-3">
          <v-btn small fab color="secondary" :to="{ path: '/projectgroups' }"><v-icon>reply</v-icon></v-btn>
          <span v-if="projectgroup" class="titleText pl-2">Project Group - {{ projectgroup.groupname }}</span>
          <span v-else class="titleText pl-2">Project Group</span>
        </h1>
        <v-alert v-if="error" :value="true" type="error">
          {{ error }}
        </v-alert>
        <template v-if="projectgroup">
          <h4>Project Group Information</h4>
          Project Group Name: <strong>{{ projectgroup.groupname }}</strong><br/>
          Project Group Description: <strong>{{ projectgroup.description }}</strong><br/>
          <v-divider class="my-3"/>
          <h4 class="pb-2">Device Types Associated with this Project Group</h4>
          <DeviceTypeListTable :parentID="projectgroup.id" v-on:error="errorHandler" />
        </template>
        <v-btn depressed @click="getNames()">
          <v-icon right>replay</v-icon>
          <span>Refresh ProjectGroup Device Names</span>
        </v-btn>
      </v-container>
    </v-content>
</template>

<script>
import DeviceTypeListTable from '@/components/Models/DeviceType/ListTable'
export default {
  name: 'ProjectGroupSingle',
  components: { DeviceTypeListTable },
  data () {
    return {
      error: false,
      id: undefined,
      projectgroup: undefined
    }
  },
  beforeMount () {
    this.id = this.$route.params.id
    if (this.id) {
      // Get project group information.
      this.$http.get('/schemas/projectgroups/' + this.id)
        .then(request => this.buildProjectGroupSingle(request.data))
        .catch(() => this.failedProjectGroupSingle())
    } else {
      this.errorHandler('Device ID not found.')
    }
  },
  methods: {
    buildProjectGroupSingle (data) {
      this.projectgroup = data.projectgroup
    },
    failedProjectGroupSingle () {
      this.errorHandler('Failed to retrieve project group.')
    },
    errorHandler (error) {
      this.error = error
    },
    failedReconcileNames () {
      this.errorHandler('Failed to request Refresh of Names.')
    },
    getNames () {
      // Reconcile ProjectGroup->device name 'description and location'
      // Quick and dirty, get confiogured default baseURL and switch out /api for /data
      var dataURL = this.$http.defaults.baseURL.replace('api', 'reconcile')
      this.$http({
        baseURL: dataURL,
        url: '/device/details?projectgroup=' + this.projectgroup.groupname
      })
        .catch(() => this.failedReconcileNames())
    }
  }
}
</script>

<style>
h1 .titleText {
  vertical-align: middle;
}
</style>
